import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-capital-details',
  templateUrl: './capital-details.component.html',
  styleUrls: ['./capital-details.component.css']
})
export class CapitalDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
